/**
 * Regex pattern string for masking name inputs (first name, last name).
 * Allows Unicode letters (any language), apostrophe, hyphen, and spaces.
 */
export const SAFE_INPUT_TEXT_MASK = '^[\\p{L}\'\\-\\s]*$'
export type SAFE_INPUT_TEXT_MASK = typeof SAFE_INPUT_TEXT_MASK

/**
 * RegExp for name inputs. Use as :mask="SAFE_INPUT_TEXT_MASK_REGEXP" with vue-imask.
 */
export const SAFE_INPUT_TEXT_MASK_REGEXP = new RegExp(SAFE_INPUT_TEXT_MASK, 'u')
export type SAFE_INPUT_TEXT_MASK_REGEXP = typeof SAFE_INPUT_TEXT_MASK_REGEXP

/**
 * RegExp for addresses.
 */
export const ADDRESS_PATTERN = /\d+\w*\s(?:[A-Za-z0-9.-]+\s?)+\.?/
export type ADDRESS_PATTERN = typeof ADDRESS_PATTERN

/**
 * RegExp for password casing.
 */
export const PASSWORD_CASING_PATTERN = /(?=.*[a-z])(?=.*[A-Z]).*$/
export type PASSWORD_CASING_PATTERN = typeof PASSWORD_CASING_PATTERN

/**
 * RegExp for password digits criteria.
 */
export const PASSWORD_DIGITS_CRITERIA_PATTERN = /((?=.*\W)|(?=.*[0-9])).*$/
export type PASSWORD_DIGITS_CRITERIA_PATTERN = typeof PASSWORD_DIGITS_CRITERIA_PATTERN

/**
 * RegExp for Matterport URLs.
 */
export const MATTERPORT_PATTERN = /^(https:\/\/my\.matterport\.com\/show\/\?)(m=\S+)$/
export type MATTERPORT_PATTERN = typeof MATTERPORT_PATTERN

/**
 * RegExp for zipcodes.
 */
export const ZIPCODE_PATTERN = /^\d{5}(-\d{4})?$/
export type ZIPCODE_PATTERN = typeof ZIPCODE_PATTERN

/**
 * RegExp for postal codes.
 */
export const POSTAL_CODE_PATTERN = /^(?![dDfFiIoOqQuUwWzZ])[a-zA-Z][0-9](?![dDfFiIoOqQuU])[a-zA-Z]( ?)[0-9](?![dDfFiIoOqQuU])[a-zA-Z][0-9]$/
export type POSTAL_CODE_PATTERN = typeof POSTAL_CODE_PATTERN

/**
 * Minimum amount of password characters.
 */
export const PASSWORD_MINIMUM_COUNT = 8
export type PASSWORD_MINIMUM_COUNT = typeof PASSWORD_MINIMUM_COUNT
